import { swapCells } from './board';
import { findMatches } from './matching';
import { Cell, COLS, Grid, ROWS } from './types';

export type SwapHint = { a: Cell; b: Cell };

export function findFirstHint(grid: Grid): SwapHint | null {
  const directions: Array<[number, number]> = [
    [0, 1],
    [1, 0],
  ];
  for (let r = 0; r < ROWS; r++) {
    for (let c = 0; c < COLS; c++) {
      for (const [dr, dc] of directions) {
        const br = r + dr;
        const bc = c + dc;
        if (br >= ROWS || bc >= COLS) continue;
        const a: Cell = { row: r, col: c };
        const b: Cell = { row: br, col: bc };
        swapCells(grid, a, b);
        const hasMatch = findMatches(grid).length > 0;
        swapCells(grid, a, b);
        if (hasMatch) return { a, b };
      }
    }
  }
  return null;
}
